var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { UTCDateTimeStringToDateString } from '../_internal/conversion/converters/UTCDateTimeStringToDate';
import { convert } from '../_internal/conversion/module';
import { validateStringArgumentNotEmpty } from '../_internal/validation';
import * as api from '../api/module';
import { paramsToString, parseRequestOptions } from '../api/util';
const convertApiToken = (input) => convert('toClient', input, {
    created: UTCDateTimeStringToDateString,
    last_modified: UTCDateTimeStringToDateString,
});
/**
 * List existing API tokens
 */
export function listAPITokens(params, requestOptions) {
    return __awaiter(this, void 0, void 0, function* () {
        requestOptions = parseRequestOptions(requestOptions);
        const query = paramsToString(params);
        const res = yield api.get(`/v2/api_tokens/${query}`, requestOptions);
        return {
            raw: res,
            content: Object.assign(Object.assign({}, res.data), { api_tokens: res.data.api_tokens.map(convertApiToken) }),
        };
    });
}
/**
 * Create a new API token
 */
export function createAPIToken(data, requestOptions) {
    return __awaiter(this, void 0, void 0, function* () {
        requestOptions = parseRequestOptions(requestOptions);
        const res = yield api.post('/v2/api_tokens/', Object.assign(Object.assign({}, requestOptions), { data: {
                metadata: data.metadata,
                relationships: data.relationships,
            } }));
        return {
            raw: res,
            content: convertApiToken(res.data),
        };
    });
}
/**
 * Retrieve an existing API token
 */
export function getAPIToken(id, requestOptions) {
    return __awaiter(this, void 0, void 0, function* () {
        validateStringArgumentNotEmpty(id, 'id');
        requestOptions = parseRequestOptions(requestOptions);
        const res = yield api.get(`/v2/api_tokens/${id}/`, requestOptions);
        return {
            raw: res,
            content: convertApiToken(res.data),
        };
    });
}
/**
 * Update an existing API token
 */
export function updateAPIToken(id, data, requestOptions) {
    return __awaiter(this, void 0, void 0, function* () {
        validateStringArgumentNotEmpty(id, 'id');
        requestOptions = parseRequestOptions(requestOptions);
        const res = yield api.patch(`/v2/api_tokens/${id}/`, Object.assign(Object.assign({}, requestOptions), { data: {
                metadata: data.metadata,
                relationships: data.relationships,
            } }));
        return {
            raw: res,
            content: convertApiToken(res.data),
        };
    });
}
/**
 * Delete an existing API token
 */
export function deleteAPIToken(id, requestOptions) {
    return __awaiter(this, void 0, void 0, function* () {
        validateStringArgumentNotEmpty(id, 'id');
        requestOptions = parseRequestOptions(requestOptions);
        const res = yield api.remove(`/v2/api_tokens/${id}/`, requestOptions);
        return {
            raw: res,
            content: res.data,
        };
    });
}
/**
 * Retrieve a site's secret
 */
export function getSiteSecret(siteId, requestOptions) {
    return __awaiter(this, void 0, void 0, function* () {
        validateStringArgumentNotEmpty(siteId, 'siteId');
        requestOptions = parseRequestOptions(requestOptions);
        const res = yield api.get(`/v2/sites/${siteId}/secret/`, requestOptions);
        return {
            raw: res,
            content: res.data,
        };
    });
}
